import { SimpleError } from '@simonbackx/simple-errors';
export var SortItemDirection;
(function (SortItemDirection) {
    SortItemDirection["ASC"] = "ASC";
    SortItemDirection["DESC"] = "DESC";
})(SortItemDirection || (SortItemDirection = {}));
export function encodeSortList(sort) {
    return sort.map(s => `${s.key} ${s.order}`).join(',');
}
export class SortListDecoder {
    static decode(data) {
        const str = data.string.trim();
        if (str === '') {
            return [];
        }
        const splitted = str.split(',');
        const list = [];
        for (const [index, part] of splitted.entries()) {
            const sub = part.trim().split(' ');
            if (sub.length > 2 || sub.length === 0) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Invalid sort list at ${data.currentField}`,
                    field: data.currentField,
                });
            }
            const direction = sub.length === 1
                ? SortItemDirection.ASC
                : data.clone({
                    data: sub[1],
                    context: data.context,
                    field: data.addToCurrentField(index),
                }).enum(SortItemDirection);
            const key = sub[0].trim();
            list.push({
                key,
                order: direction,
            });
        }
        return list;
    }
}
//# sourceMappingURL=SortList.js.map